import { setSaveEnabled } from "@/views/workspace/board/detail/helper/boardSave";
import { clearBoardSnapshots } from "@/views/workspace/board/detail/helper/storage";
import { clearSplitSessionSnapshot } from "@/views/workspace/board/detail/components/ImageContextToolbar/GameUiSplitterPanel/composables/useSplitSessionSnapshot";
import { useGenerationParamStore } from "@/views/workspace/board/detail/helper/store/generationParam";

/** 登出或跨标签页认证重置时清理画布相关的本地用户数据。 */
export async function clearBoardLocalData(): Promise<void> {
  setSaveEnabled(false);

  // 拆分恢复快照（game-ui-splitter:resume:active）不分用户维度，登出必须物理清除，
  // 否则同浏览器换账号登录会按旧账号会话自动恢复拆分（QA 9-7-2 退出重登错乱）
  clearSplitSessionSnapshot();

  const results = await Promise.allSettled([clearBoardSnapshots(), useGenerationParamStore().clearAll()]);
  for (const result of results) {
    if (result.status === "rejected") {
      console.warn("[Board] Failed to clear local canvas data:", result.reason);
    }
  }
}
